import React, { useState } from 'react';
import { 
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Collapse,
  IconButton,
  Avatar,
  Box,
  Flex,
  Heading,
  Divider,
 } from '@chakra-ui/react';
import { MdExpandLess, MdExpandMore } from 'react-icons/md';
import moment from 'moment';

import { USER_DATE_FORMAT } from '@app/utils';

import { EquipmentRepairOrder } from '../../api/models/equipment';
import FieldView from '../common/field-view';
import GalleryModal from '../common/modals/gallery';
import { Txt } from '../common/text';

export default function RepairCard({ item }: { item: EquipmentRepairOrder }) {
  const [expanded, setExpanded] = React.useState(false);

  const [showGallery, setShowGallery] = useState<boolean>(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (<>
      <Card mb={4}>
        <CardHeader>
          <Heading mb={2} size='sm' textAlign='end' w='100%' color='gray.400'>Сервисная заявка #{item.id}</Heading> 
          <Flex gap='4'>
            <Flex flex='1' gap='4' alignItems='center' flexWrap='wrap'>
              <Avatar name={item.service_data.model?.name} />
              <Box flex={1}>
                <Heading size='sm'>{item.service_data.model?.name}</Heading>
                <Txt>{item.service_data.manufacturer?.name}</Txt>
              </Box>
              <Flex alignItems='flex-end' flexDirection='column'>
                <FieldView title="SN" value={item.service_data.serial_num} direction='row' fullWidth noPB />
                <FieldView title="Инв." value={item.service_data.inventory_num} direction='row' fullWidth noPB />
              </Flex>
            </Flex>
          </Flex>
        </CardHeader>
        <CardBody mt={-4} mb={-4}>
          <Flex gap={4} alignItems='flex-start' justify='space-between' flexWrap='wrap' mb={1}>
            <Txt color="gray.500">{moment(item.visit_dt).format(USER_DATE_FORMAT)}</Txt>
            <Txt color="brand.500">{item.status?.name}</Txt>
          </Flex>
          <FieldView title="Комментарий координатора" value={item.coordinator_comment} fullWidth />
          <FieldView title="Торговая точка" value={item.service_data.outlet?.name} direction='row' fullWidth />
          <FieldView title="Тип сервиса" value={item.service_data.problem?.name} direction='row' fullWidth />   
        </CardBody>
        <Divider />
        <CardFooter>
          <Flex ml={1} justify='space-between' w='100%'>
            <Txt variant="caption">
              Подробнее
            </Txt>
            <IconButton
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
              icon={expanded ? <MdExpandLess size={24} /> : <MdExpandMore size={24} />}
              size='sm'
            />
          </Flex>
        </CardFooter>
        <Collapse in={expanded} unmountOnExit>
          <CardBody mt={-4}>
            <FieldView title="Комментарий" value={item.service_data.comment} fullWidth />
            <Box mt={2}>
              <FieldView title="Инициатор" value={item.user?.full_name} direction='row' fullWidth />
              <FieldView title="Торговая точка" value={item.service_data.outlet?.name} direction='row' fullWidth />
              <FieldView title="Адрес" value={item.service_data.full_address} fullWidth />
              <FieldView title="Сервисный организация" value={item.department?.name} direction='row' fullWidth />
              <FieldView title="Дата визита исполнителя" value={item.technical_visit_dt && moment(item.technical_visit_dt).format(USER_DATE_FORMAT)} direction='row' fullWidth /> 
              <FieldView title="Комментарий исполнителя" value={item.technical_comment} direction='row' fullWidth />
            </Box>
          </CardBody>
        </Collapse>
      </Card>
      <GalleryModal
        images={item.images || []}
        open={showGallery}
        onClose={() => setShowGallery(false)}
        title="Изображения"
      />
    </>
  );
}
